import { BookButton } from "features/BookButton";
import classNames from "lib/classNames";
import TrackProgress from "components/progress/TrackProgress/TrackProgress";
import EditableCurrentProgress from "components/progress/EditableCurrentProgress/EditableCurrentProgress";
import ProgressSlider from "components/progress/ProgressSlider/ProgressSlider";
import { audioReadingFormat } from "types/ReadingFormatType";
import { debounce } from "lodash";
import { EditionSerializersEdition, LetterbooksSerializersBook, UserBookSerializersUserBook, UserBookSerializersUserBookDate } from "types/serializers";

export default function CurrentlyReadingProgress({
  book,
  edition,
  isOwner,
  onProgressChange,
  trackRead,
  userBook,
  userBookRead,
}: {
  book: LetterbooksSerializersBook;
  edition: EditionSerializersEdition;
  isOwner: boolean;
  onProgressChange: (newProgress: number) => Promise<any>;
  userBook: UserBookSerializersUserBook;
  userBookRead?: UserBookSerializersUserBookDate;
  trackRead: () => void;
}) {
  const shouldTrackProgress = !userBookRead && isOwner;
  if (!userBook) {
    return false;
  }

  const debouncedChange = debounce(onProgressChange, 500);
  const duration =
    edition?.readingFormatId === audioReadingFormat.id
      ? edition?.audioSeconds
      : edition?.pages;
  const hasDuration = duration > 0;

  return (
    <div className="flex flex-col my-2 space-y-8 w-full">
      <div
        className={classNames(
          "flex flex-row gap-4",
          shouldTrackProgress ? "justify-start items-center" : hasDuration
            ? "justify-start items-center"
            : "justify-between items-baseline"
        )}
      >
        <BookButton
          bookId={book.id}
          size="sm"
          referrerUserId={userBook.userId}
        />

        { shouldTrackProgress ? (
          <TrackProgress trackRead={trackRead} />
        ) : (
          <div
            className={classNames(
              "flex flex-col space-y-1",
              hasDuration ? "grow" : ""
            )}
          >
            <EditableCurrentProgress
              book={book}
              edition={edition}
              onChange={onProgressChange}
              userBookRead={userBookRead}
              isOwner={isOwner}
            />
          </div>
        )}
      </div>

      { !shouldTrackProgress ? (
        <ProgressSlider
          readingFormatId={edition?.readingFormatId || 1}
          progressNumber={
            edition?.readingFormatId === audioReadingFormat.id
              ? userBookRead?.progressSeconds
              : userBookRead?.progressPages
          }
          progressMax={duration}
          onChange={isOwner ? debouncedChange : null}
        />
      ) : null}
    </div>
  );
}
